import { motion } from 'framer-motion';
import { luxuryEase, viewportOnce } from '../lib/motion';

const items = [
  { n: '01', title: 'Mühendislik', text: 'Depreme dayanıklı yapı, sahada kontrol.' },
  { n: '02', title: 'Mimari', text: 'Villadan siteye tutarlı tasarım dili.' },
  { n: '03', title: 'Teslim', text: 'Sözleşme takvimi, şeffaf süreç.' },
];

export default function Stats() {
  return (
    <section className="bg-nosta-paper">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-nosta-line border-x border-nosta-line">
          {items.map((item, i) => (
            <motion.div
              key={item.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={viewportOnce}
              transition={{ delay: 0.12 * i, duration: 0.85, ease: luxuryEase }}
              className="px-8 py-10"
            >
              <div className="eyebrow mb-4">{item.n}</div>
              <h3 className="font-display text-3xl mb-2">{item.title}</h3>
              <p className="text-nosta-mute leading-relaxed">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
